export default __webpack_public_path__ + "static/media/home_textile.9c435bd9.png";